export default __webpack_public_path__ + "static/media/Vector-1.93ef8947.svg";